export const SANITIZATION_TYPES = {
    WHITE_LIST: Symbol('WHITE_LIST'),
    BLACK_LIST: Symbol('BLACK_LIST'),
    ANGLE_BRACKETS: Symbol('ANGLE_BRACKETS'),
    REGEXP: Symbol('REGEXP'),
    DIGITS_ONLY: Symbol('DIGITS_ONLY')
};

function getRegularExpression(reg, flags = '', replaceFlags = false) {
    if (reg instanceof RegExp) {
        if (!replaceFlags) {
            const flagsArray = flags.split('').concat(reg.flags.split(''));
            flags = _.uniq(flagsArray).join('');
        }
        return new RegExp(reg, flags);
    }
    if (typeof reg === 'string') return new RegExp(reg, flags);
    if (Array.isArray(reg)) {
        const onlyStrings = reg.filter(element => typeof element === 'string');
        return new RegExp(`(${onlyStrings.join(')|(')})`, flags);
    }
    return new RegExp('');
}

export function Regexp(sanitizeRegExp, value) {
    return value.replace(getRegularExpression(sanitizeRegExp, 'g'), '');
}

export function WhiteList(whilteList = [], value) {
    throw new Error('Not implemented yet!');
}

export function BlackList(blackList = [], value) {
    return Regexp(blackList, value);
}

export function AngleBrackets(value) {
    return Regexp(/<.*>/g, value);
}

export function DigitsOnly(value) {
    return Regexp(/[^\d]/g, value);
}

export function sanitize(val, replaceInValue) {
    const value = val.toString();
    if (replaceInValue) {
        switch (typeof replaceInValue) {
            case 'function':
                return replaceInValue(value);
            case 'object':
                try {
                    return Object.keys(replaceInValue).reduce(
                        (result, key) => result.replace(getRegularExpression(replaceInValue[key]), key),
                        value
                    );
                } catch (e) {
                    break;
                }
            default:
                break;
        }
    }
    return value;
}



// WEBPACK FOOTER //
// ./src/components/common/sanitizationTypes.js